document.addEventListener("turbo:load", loadGlobals);

window.addEventListener("trix-file-accept", function(event) {
  const acceptedTypes = ['image/jpeg', 'image/png', 'image/gif'];
  if (!acceptedTypes.includes(event.file.type)) {
    event.preventDefault();
    alert("Only image uploads are supported (jpg, png, gif). Please choose another file.");
  }
});

function loadGlobals() {
	console.log('Load: spurimpact/globals.js');

  $('.therm').each(function() {
    var $this = $(this);
    var $progress = $(this).find('.therm_progress');
    var total = $(this).data('total');
    var current = $progress.data('current');
    var percent = (current / total) * 100;

    if (percent > 100) percent = 100;
    if (percent > 0 && percent < 2) percent = 2; // minimum visible width (2%)

    $progress.animate(
      {
        width: percent + "%",
        opacity: 1
      },
      1500,
      function() {
        var $current = $this.find('.therm_goal_current');
        if ($current.length > 0) {
          $current.css('width', percent + "%").fadeIn();
        }
      }
    );
  });

  $('.admin_guide_btn').on("click", function() {
		$(this).next('.admin_guide').slideToggle('fast');
	});

  $('.notice').on("click", function(e) {
		if ( !$(this).hasClass('clickable') ) {
			e.preventDefault();
			$(this).slideUp();
		}
	});

	// Validation
	$('input:required').one('blur keydown input', function(e) {
		// console.log('touched', this);
		$(this).addClass('touched');
		// console.log( this.validity );

		if (this.validity.valid) {
			$(this).closest('.form_field').removeClass('form_field_error');
		} else {
			$(this).closest('.form_field').addClass('form_field_error');
		}
	});

  // donations & cart
  $(function () {
    const $container = $(".success_social_share");

    if ($container.length === 0) return;
    if (!navigator.share) return;

    const $nativeShare = $container.find(".native-share");
    $nativeShare.removeClass("d-none");

    $container.on("click", ".nativeShare", function (e) {
      e.preventDefault();

      navigator.share({
        title: "Share your impact!",
        text: $container.data("text"),
        url: $container.data("url")
      });
    });
  });
};

